/**
 * resetQueryByParams
 * @param rootStore 
 * @returns 
 */
export function resetQueryByParams(query: any = {}, params: any = {}) {
  Object.keys(query).forEach((key: any) => {
    if (![undefined, query[key]].includes(params[key])) {
      Object.assign(query, { [key]: params[key] })
    }
  })
}